import { PUBLIC_MAGENTO_ENDPOINT } from '$env/static/public';
import { storeCustomerToken, storeCartError, storeLoggedUser, storeUserCart } from '$lib/js/stores';
import { getCart, getCustomerToken } from './cart';
import { gt } from 'svelte-i18n-lingui'
import type { AddToCartError, AddToCartItem, Cart, CartItem, CartItemInputInfo } from '$lib/js/magento/cart/types'
import type { CustomerToken } from '../types';

export async function magentoAddToGuestCart(
  item: { cartItem: AddToCartItem },
  cart_data: Cart
): Promise<CartItem | AddToCartError> {
  const itemWithoutQuoteID: { cartItem: Record<string, any> } = { cartItem: { ...item.cartItem } }
  delete itemWithoutQuoteID?.cartItem?.quote_id

  let request = await magentoAddToGuestCartRequest(item, cart_data)
  let result: CartItem | AddToCartError | undefined

  // Exception: if the user has no rights, log them out and create a new guest cart
  if(request.status !== 200) {
		console.log('ERROR ADDING ITEM TO GUEST CART', request)
    storeUserCart.set({} as Cart)
    storeLoggedUser.set(false)
		storeCustomerToken.set({} as CustomerToken)

    await fetch(`${PUBLIC_MAGENTO_ENDPOINT}/es/customer/account/logout/`).then(async () => {
      await getCustomerToken()
      await getCart().then(async (cart_info) => {
        request = await magentoAddToGuestCartRequest(item, cart_info)
      })
    })
  }

  result = await request.json()

  if((<AddToCartError>result).message) {
    storeCartError.set(gt`The product could't be added to your basket. Please try again later or <a href="/en/contact">contact us</a>.`)
  }

  return result as CartItem;
}

/**
 * Add product to client cart and return the raw response.
 */
export async function magentoAddToGuestCartRequest(item: { cartItem: AddToCartItem }, cart_data: Cart) {
  return await fetch(
    `${PUBLIC_MAGENTO_ENDPOINT}/rest/V1/guest-carts/${cart_data.masked_id}/items`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: 'application/json',
      },
      body: JSON.stringify(item),
    }
  );
}



/**
 * Add product to client cart
 */
export async function updateGuestCartItem(item: CartItemInputInfo, cart_data: Cart) {
  const cart_item = {
    "cartItem": {
      "qty": item.cart_qty || 1,
      "sku": item.sku,
      "quote_id": cart_data.masked_id,
    }
  }

  const response = await fetch(
    `${PUBLIC_MAGENTO_ENDPOINT}/rest/V1/guest-carts/${cart_data.masked_id}/items/${item.item_id}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: 'application/json'
      },
      body: JSON.stringify(cart_item),
    }
  );

  return await response.json() as CartItem;
}


/**
 * Remove item from guest cart
 */
export async function removeFromGuestCart(item_id: number, cart_data: Cart) {
  const response = await fetch(
    `${PUBLIC_MAGENTO_ENDPOINT}/rest/V1/guest-carts/${cart_data.masked_id}/items/${item_id}`,
    {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Accept: 'application/json',
      },
    }
  );
  return await response.json() as boolean;
}
